import axios from 'axios';
import { NewsArticle } from '../data/news';
import i18n from '../i18n/i18n'; // Chemin correct vers le fichier i18n

// Configuration des URLs d'API selon l'environnement
const getApiUrl = (): string => {
  if (process.env.NODE_ENV === 'production') {
    // Production avec app.itmonkeys.fr
    return 'https://app.itmonkeys.fr/api';
  }
  
  // Développement avec localhost
  const serverHost = process.env.REACT_APP_SERVER_HOST || 'localhost';
  const serverPort = process.env.REACT_APP_SERVER_PORT || '1337';
  return `http://${serverHost}:${serverPort}/api`;
};

const API_URL = getApiUrl();

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Helper pour obtenir la locale courante
const getCurrentLocale = (): string => {
  return i18n.language || 'fr';
};

export const fetchAllArticles = async (): Promise<NewsArticle[]> => {
  try {
    const locale = getCurrentLocale();
    const response = await api.get(`/articles/${locale}`);
    return response.data.articles;
  } catch (error) {
    console.error('Error fetching articles:', error);
    throw error;
  }
};

export const fetchArticleBySlugAndCategory = async (
  category: string,
  slug: string
): Promise<NewsArticle> => {
  try {
    const locale = getCurrentLocale();
    const response = await api.get(`/articles/${category}/${slug}/${locale}`);
    return response.data.article;
  } catch (error) {
    console.error('Error fetching article details:', error);
    throw error;
  }
};

export const fetchArticlesByCategory = async (category: string): Promise<NewsArticle[]> => {
  try {
    const locale = getCurrentLocale();
    const response = await api.get(`/articles/category/${category}/${locale}`);
    return response.data.articles;
  } catch (error) {
    console.error(`Error fetching articles in category ${category}:`, error);
    throw error;
  }
};

export default api; 